/** Search all visible columns (default). */
export const SEARCH_ALL_COLUMNS = '__all__';
